import { Injectable, inject } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { PartnerInscriptionDraftService } from '../services/partner-inscription-draft.service';

@Injectable({
  providedIn: 'root',
})
export class PartnerInscriptionLeaveGuard implements CanDeactivate<unknown> {
  private draftService = inject(PartnerInscriptionDraftService);


  canDeactivate(): boolean {
    return this.draftService.consumeWizardRouteChangePermission();
  }
}
